import { render } from "./IDDetails2.vue?vue&type=template&id=207cdd95&scoped=true&ts=true"
import script from "./IDDetails2.vue?vue&type=script&lang=ts"
export * from "./IDDetails2.vue?vue&type=script&lang=ts"

import "./IDDetails2.vue?vue&type=style&index=0&id=207cdd95&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207cdd95"],['__file',"src/components/kyc/IDDetails2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "207cdd95"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('207cdd95', __exports__)) {
    api.reload('207cdd95', __exports__)
  }
  
  module.hot.accept("./IDDetails2.vue?vue&type=template&id=207cdd95&scoped=true&ts=true", () => {
    api.rerender('207cdd95', render)
  })

}


export default __exports__